import { NgModule } from '@angular/core';
import { AppModule } from './app.module';
import { AppComponent } from './app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { SocialLoginModule, FacebookLoginProvider } from '@abacritt/angularx-social-login';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from './environments/environments';

@NgModule({
  imports: [
    AppModule,
    StoreDevtoolsModule.instrument({ maxAge: 25 }),
    SocialLoginModule.initialize({
      autoLogin: false,
      providers: [
        {
          id: FacebookLoginProvider.PROVIDER_ID,
          provider: new FacebookLoginProvider('2488442388239297')
        }
      ],
      onError: (err) => {
        console.error(err);
      }
    }),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
  ],
  bootstrap: [AppComponent]
})
export class AppBrowserModule {}
